<template>
  <span>
    <span v-if="!menu" class="action"> 
      <button v-if="buttonType" @click.prevent="openMoveUpModal" >
        <i  v-if="!buttonType"  @click.stop="openMoveUpModal" class="fal fa-arrow-up"></i>
      </button>
      <i  v-if="!buttonType"  @click.stop="openMoveUpModal" class="fal fa-arrow-up"></i><span class="label">{{moveUpLabel}}</span>
    </span>
    <span v-if="menu"
      @click.stop="openMoveUpModal"
      :class="iconOnly ? 'action' : ''"
    >
      <i   class="fal fa-arrow-up"></i><span class="">{{moveUpLabel}}</span>
    </span>
    <div :class="[{ open: moveUpModalStatus }, 'modal', 'moveup-confirmation-modal']">
      <div class="shadow" @click="closeMoveUpModal"></div>
      <div class="body">
        <i class="fal fa-times exit" @click="closeMoveUpModal"></i>
          <div >
            <div class="heading">Are you sure you want to move this?</div>
            <div class="actions">
              <div class="left">
                <button class="secondary" @click.stop.prevent="closeMoveUpModal">Cancel</button>
              </div>
              <div class="right">
                  <button class="primary" @click.stop.prevent="doMoveUp">Confirm</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import RallyPaginationMixin from "../components/RallyPaginationMixin";  
//import ContentMixin from "../components/ContentMixin";  
import {findDefaultChannelObjOfType,grandParentContextId,grandParentContextType, findDefaultChannelOfTypeForRally } from "../common";
import { eventBus } from "../main.js";
  export default {
    //mixins: [RallyPaginationMixin, ContentMixin],
    props: ['content', 'rallyId', 'channelId', 'menu', 'type', 'contextShare', 'iconOnly'],
    data: function() {
      return {
        moveUpModalStatus: false,
        isLoading: true,
        step: 1,
        cbChanges:[],
        page: 1
      };
    },
    created () {

    },
    computed: {
      ...mapState("rallies", ["allRallies", "rallyChannelsByRallyId", "ralliesByParent", "allRalliesByRallyId"]),
      ...mapState("contents", ["contentById", "allContentByContextTypeAndId"]),
      ...mapState("shares", ["sharesByContentId"]),
      //...mapState("channels", ["rallyChannelsByRallyId"]),
      buttonType(){
        return this.type == 'button'
      },
      moveUpLabel(){
        if (this.iconOnly){
          return ""
        } else if (this.menu){
          return "Move Up"
        } else {
          return ""
        }
      }
    },
    methods: {
      ...mapActions("contents", ["flagContent",  "clearContentItemFromContexts", "setContentById", "moveContent"]),
      ...mapActions("shares", [ "fetchSharesByContentId"]),
      async doMoveUp() {
        const destinationId = grandParentContextId(this.$route.path, this.channelId);
        const destinationType = grandParentContextType(this.$route.path); 
        //console.log("channels:" , this.rallyChannelsByRallyId)
        let galleryChan = findDefaultChannelOfTypeForRally(
          "Gallery",
          this.rallyChannelsByRallyId,
          this.rallyId
        );
        let isGallery = this.channelId == galleryChan
        await this.moveContent({
          shareId: this.contextShare.id,
          destinationId,
          destinationType
        });

        this.closeMoveUpModal();
        this.$emit('perform', 'handleLightboxHide');

        const rawType = this.content?.attributes?.['file-type'];
        const fileType = (rawType || '').toString().toLowerCase();
        //const isPhoto = fileType === 'photo';

        if (destinationType === "Channel") {
         alert(
            isGallery
              ? 'Success! You have moved your photo to the main gallery page.'
              : 'Success! You have moved your file to the top.'
          );
        } else {
          const folder = this.contentById?.[destinationId];
          const label = isGallery ? 'photo' : 'file';
          const name = folder?.attributes?.title;

         alert(
            name
              ? `Success! You have moved your ${label} up to: ${name}`
              : `Success! You have moved your ${label} up.`
          );
        }
        window.location.reload();
      },
      closeMoveUpModal() {
        this.moveUpModalStatus = false;
      },
      openMoveUpModal() {
        this.moveUpModalStatus = true;
      }
    }
  }
</script>
